import { Stack, useColorModeValue } from "@chakra-ui/react";

function ProfileBox({ children, ...props }) {
  const bgColor = useColorModeValue("#fff", "#020B19");

  return (
    <Stack
      p="15px 40px"
      borderRadius={"6px"}
      bg={bgColor}
      mb="20px !important"
      mr={["unset", "20px !important"]}
      boxShadow={"-1px 1px 2px #00000003"}
      {...props}
    >
      {children}
    </Stack>
  );
}

export default ProfileBox;
